// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".provider-icon,.provider-icon img{border-radius:20%}.provider-icon--labelled{overflow:hidden;height:100%;display:flex;justify-content:center;align-items:center;font-size:1.2rem}.provider-icon--labelled.timeline__provider-block__logo{font-size:.7rem}", ""]);
// Exports
module.exports = exports;
